/**
 * @generated SignedSource<<5c491dfd9d3891c5861489a99ec55753>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesCheckShopifyTestStoreQuery$variables = {
  salesChannelID?: number | null;
};
export type salesChannelSwitchQueriesCheckShopifyTestStoreQuery$data = {
  readonly shopifyAuthEcommerceSettings: {
    readonly isTestStore: boolean;
  } | null;
};
export type salesChannelSwitchQueriesCheckShopifyTestStoreQuery = {
  response: salesChannelSwitchQueriesCheckShopifyTestStoreQuery$data;
  variables: salesChannelSwitchQueriesCheckShopifyTestStoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "concreteType": "ShopifyAuthEcommerceSettings",
    "kind": "LinkedField",
    "name": "shopifyAuthEcommerceSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTestStore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesCheckShopifyTestStoreQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesCheckShopifyTestStoreQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "99ff0ef9d639a06d56ef4526571cb48d",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesCheckShopifyTestStoreQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesCheckShopifyTestStoreQuery(\n  $salesChannelID: Long\n) {\n  shopifyAuthEcommerceSettings(salesChannelID: $salesChannelID) {\n    isTestStore\n  }\n}\n"
  }
};
})();

(node as any).hash = "3521f463f156790ededa6f2a2c4604a9";

export default node;
